import { type RefObject, useEffect, useRef } from 'react'
import { prefetchVideoHead } from '@/lib/videoPrefetch'

const SP_BREAKPOINT = 768

/**
 * SPでサムネイル領域が画面内に入ったとき、指定動画の出だしだけを1回先読みする。
 * 通信量を抑えるため、同一コンポーネント内では最初の1本だけを対象にする。
 */
export const useViewportVideoPrefetch = (
  targetRef: RefObject<Element | null>,
  videoUrl: string | null | undefined,
  enabled = true,
) => {
  const hasPrefetchedRef = useRef(false)

  useEffect(() => {
    if (!enabled || !videoUrl || hasPrefetchedRef.current) return
    if (typeof window === 'undefined' || typeof IntersectionObserver === 'undefined') return
    if (window.innerWidth >= SP_BREAKPOINT) return

    const target = targetRef.current
    if (!target) return

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry?.isIntersecting || hasPrefetchedRef.current) return
        hasPrefetchedRef.current = true
        prefetchVideoHead(videoUrl)
        observer.disconnect()
      },
      { rootMargin: '120px 0px', threshold: 0.1 },
    )

    observer.observe(target)
    return () => observer.disconnect()
  }, [enabled, targetRef, videoUrl])
}
